<template lang="pug">
  v-navigation-drawer(
    app
    width="200"
    v-if="visible"
    mini-variant-width="60"
    :mini-variant="mini"
    :permanent="true"
  )
    v-list(dense)
      v-list-item
        v-list-item-icon
          v-icon(color="red") local_bar
        v-list-item-content
          v-list-item-title Syndacast

      v-divider

      v-list-item.mt-3
        v-list-item-icon
          v-icon dashboard
        v-list-item-content
          v-list-item-title Dashboard

      template(v-for="(group, key) in groups")
        v-subheader {{ group.name }}
        v-list-item-group
          v-list-item(v-for="(item, k) in group.items" :key="k" :to="getItemTo(item)")
            v-list-item-icon
              v-icon {{ item.icon }}
            v-list-item-content
              v-list-item-title {{ item.name }}

    template(v-slot:append)
      v-list-item(dense to="/logout")
        v-list-item-icon
          v-icon exit_to_app
        v-list-item-content
          v-list-item-title Logout
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      groups: [
        // {
        //   name: 'GOOGLE',
        //   items: [
        //     {
        //       name: 'Ad Manager',
        //       icon: 'subject',
        //       route: 'google-ads'
        //     },
        //     {
        //       name: 'Bid Manager',
        //       icon: 'attach_money',
        //       route: null
        //     },
        //     {
        //       name: 'Campaign Manager',
        //       icon: 'equalizer',
        //       route: null
        //     }
        //   ]
        // },
        {
          name: 'TOOLS',
          items: [
            {
              name: 'Travelanium',
              icon: 'swap_vertical_circle',
              route: 'travelanium'
            },
            {
              name: 'Hotel Link',
              icon: 'swap_vertical_circle',
              route: 'hotellink'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      'visible': 'navigation/isVisible',
      'mini': 'navigation/isMini'
    }),
    active () {
      return true
    }
  },
  methods: {
    getItemTo (item) {
      const value = item.route || {}
      return (value.url)
        ? { path: value.url }
        : { name: item.route }
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-list-item
  &__content
    margin-left: -16px
</style>
